import store from '@/store/index'
import {AxiosPromise} from 'axios'

let startRequest = 0
let timeout = 0
export default class LoaderBar {
  public static start (request: AxiosPromise) {
    clearTimeout(timeout)
    if (!startRequest) startRequest = Date.now();
    store.commit('appInterface/setLoaderBar', true);
    store.commit('appInterface/addRequest', request);
  }

  public static stop (request: AxiosPromise) {
    store.commit('appInterface/removeRequest', request);
    if (!store.state.appInterface.httpRequests.length) {
      clearTimeout(timeout)
      timeout = setTimeout(function () {
        store.commit('appInterface/setLoaderBar', false);
      }, Date.now() - startRequest > 1000 ? 0 : 1000)
      startRequest = 0
    }
  }
}